import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import TariffGridView from 'components/TariffGrid';
import Tooltip from 'shared/components/Tooltip';
import { TariffGridFragment_tariffGrid as TariffGrid } from 'components/TariffGrid/__generated__/TariffGridFragment';

import './index.scss';

interface Props {
  tariffGrid: TariffGrid;
}

const b = b_.with('idea-top-card-fees-tariff');

export const TariffView: React.FC<Props> = ({ tariffGrid }) => {
  const { t } = useTranslation();
  return (
    <div>
      {t('Depends on request amount')}
      <Tooltip
        placement="bottomRight"
        trigger={['click']}
        overlay={
          <div className="rc-overlay">
            <TariffGridView grid={tariffGrid} />
          </div>
        }
      >
        <span className={b('hint')}>?</span>
      </Tooltip>
    </div>
  );
};
